export default __webpack_public_path__ + "static/media/miles_art.2ee2b524.png";